module.exports = __webpack_public_path__ + "static/media/sample-activity-report-uk.01a8165a.pdf";